import pw6 from './pics/pw6.png'
import mmz from './pics/mmz.png'
import mmz2 from './pics/mmz2.png'
import gpp from './pics/gpp.png'
import mmz3 from './pics/mmz3.png'
import mmz4 from './pics/mmz4.jpg'
import fe3h from './pics/fe3h.png'
import SF64 from './pics/SF64.jpg'
import cs3 from './pics/cs3.png'
import revue from './pics/revue.png'
import bunnygirl from'./pics/bunnygirl.jpg'
import soriyori from './pics/soriyori.jpg'
import smo from './pics/SMO.jpg'
import helltaker from './pics/helltaker.jpg'
import joshiraku from './pics/joshiraku.png'
import heartcatchprecure from './pics/heartcatchprecure.jpg'
import saoaggo2 from './pics/saoaggo2.png'
import hollowknight from './pics/hollowknight.png'
import asg2 from './pics/asg2.png'
import Futari_wa_Pretty_Cure from './pics/futariwaprecure.png'
import yatogame from './pics/Yatogame2.png'
import kaguya2 from './pics/kaguya2.png'
import priconne from './pics/priconne.png'
import mobpsycho from './pics/mobpsycho.png'
import junitaisen from './pics/junitaisen.jpg'
import sekiro from './pics/sekiro.jpg'
import bloodstained2 from './pics/bloodstained2.png'
import saoa1 from './pics/saoa1.png'
import tsugumomo from './pics/tsugumomo1.png'
import tsugumomo2 from './pics/tsugumomo2.png'
import re2 from './pics/re2.jpg'
import arr from './pics/arr.png'
import umayon from './pics/Umayon.png'
import re4 from './pics/re4.jpg'
import undertaleneutral from './pics/undertaleneutral.png'
import undertalepacifist from './pics/undertalepacifist.jpg'
import AC7 from './pics/AC7.jpg'
import ikaruga from './pics/ikaruga.jpg'
import bunnydream from './pics/bunnydream.jpg'
import catreturns from './pics/catreturns.jpg'
import saoa2 from './pics/saoa2.png'
import goose from './pics/goose.jpg'
import sonicmania from './pics/sonicmania.png'
import sonicgenerations from './pics/sonicgenerations.png'
import celeste from './pics/celeste.jpg'
import re5 from './pics/re5.png'
import elaina1 from './pics/elaina1.jpg'
import luminousavenger from './pics/luminousavenger.png'
import elaina2 from './pics/elaina2.png'
import mmx from './pics/mmx.jpg'
import demonslayermanga from './pics/demonslayermanga.png'
import celestefarewell from './pics/celestefarewell.png'
import Assassination_Classroom from './pics/assassinationclassroom.jpg'
import tonikawa from './pics/tonikawa.png'
import elainaS1 from './pics/elainaS1.png'
import haikyuuS4 from './pics/haikyuu.png'
import touhoulunanight from './pics/touhoulunanight.png'

export default [
    {
        image: pw6,
        title: 'Phoenix Wright Spirit of Justice',
        color: '#800000',
        date: '02/20',
        url:'https://en.wikipedia.org/wiki/Phoenix_Wright:_Ace_Attorney_%E2%88%92_Spirit_of_Justice', 
        text: "Your reign of terror...ends here!",
        tags: ['Game', '3DS']
    },
    {
        image: mmz,
        title: 'Megaman Zero',
        color: '#008080',
        date: '02/25/20',
        url:'https://en.wikipedia.org/wiki/Mega_Man_Zero',
        text: "I won't stop! When an enemy appears...I'll terminate it...",
        tags: ['Game', 'PS4', 'Replay', '★']
    },
    {
        image: mmz2,
        title: 'Megaman Zero 2',
        color: '#800000',
        date: '03/14/20',
        url:'https://en.wikipedia.org/wiki/Mega_Man_Zero_2',
        text: "Let's go...",
        tags: ['Game', 'PS4', 'Replay', '★']
    },
    {
        image: mmz3,
        title: 'Megaman Zero 3',
        color: '#B22222',
        date: '03/21/20',
        url:'https://en.wikipedia.org/wiki/Mega_Man_Zero_3',  
        text: "It's just me...I am...Zero",
        tags: ['Game', 'PS4', 'Replay', '★']
    },
    {
        image: yatogame,
        title: 'Yatogame-chan Kansatsu Nikki 2 Satsume',
        color: '#006400',
        date: '03/23/20',
        url:'https://en.wikipedia.org/wiki/Go!_Princess_PreCure',
        text: "Enjoy it as a program filled with love for Nagoya.",
        tags: ['Anime', 'Comedy']
    },
    {
        image: fe3h,
        title: 'Fire Emblem 3 Houses Crimson Flower',
        color: '#B22222',
        date: '03/24/20',
        url:'https://en.wikipedia.org/wiki/Fire_Emblem:_Three_Houses',
        text: "I'm determined as ever to see this through to the end. I will defeat the false goddess.",
        tags: ['Game', 'PS4', 'Replay']
    },
    {
        image: gpp,
        title: 'Go! Princess Precure',
        color: '#C71585',
        date: '03/31/20',
        url:'https://en.wikipedia.org/wiki/Go!_Princess_PreCure',
        text: "Thank you...for daring to dream and leading me to such bliss.",
        tags: ['Anime', 'Mahou Shoujo', '★']
    },
    {
        image: revue,
        title: 'Revue Starlight',
        color: '#4169E1',
        date: '04/1/20',
        url:'https://en.wikipedia.org/wiki/Revue_Starlight',
        text: "Position Zero!",
        tags: ['Anime', '★']
    },
    {
        image: mmz4,
        title: 'Megaman Zero 4',
        color: '#A0522D',
        date: '04/05/20',
        url:'https://en.wikipedia.org/wiki/Mega_Man_Zero_4',
        text: "I never cared about justice, and I don't recall ever calling myself a hero...I have always only fought for the people I believe in. I won't hesitate...If an enemy appears in front of me, I will destroy it!",
        tags: ['Game', 'PS4', 'Replay', '★']
    },
    {
        image: SF64,
        title: 'Star Fox 64',
        color: '#006400',
        date: '04/22/20',
        url:'https://en.wikipedia.org/wiki/Star_Fox_64',
        text: "Can't let you do that Star Fox.",
        tags: ['Game', 'N64', 'Replay']
    },
    {
        image: cs3,
        title: 'Castlevania Season 3',
        color: '#191970',
        date: '04/20',
        url:'https://en.wikipedia.org/wiki/Castlevania_(TV_series)',
        text: "We've spent a couple of months living in your life. With adventures and victories. And now, we are living in my life.",
        tags: ['Anime', '★']
    },
    {
        image: bunnygirl,
        title: 'Rascal Does Not Dream of Bunny Girl Senpai',
        color: '#1E90FF',
        date: '04/20',
        url: 'https://en.wikipedia.org/wiki/Rascal_Does_Not_Dream_of_Bunny_Girl_Senpai',
        tags: ['Anime']
    },
    {
        image: soriyori,
        title: 'A Place Further Than The Universe',
        color: '#87CEEB',
        date: '04/20',
        url:'https://en.wikipedia.org/wiki/A_Place_Further_than_the_Universe',
        text: "Dear Mom",
        tags: ['Anime', 'Drama', '★']
    },
    {
        image: smo,
        title: 'Super Mario Odyssey',
        color: '#800000',
        date: '05/08/20',
        url:'https://en.wikipedia.org/wiki/Super_Mario_Odyssey',
        text: "Smash through the blocks that bar your way. No time for fear just let it all fall away.",
        tags: ['Game', 'Switch']
    },
    {
        image: demonslayermanga,
        title: 'Demon Slayer: Kimetsu no Yaiba - Manga',
        color: '#708090',
        date: '05/17/20',
        url:'https://en.wikipedia.org/wiki/Demon_Slayer:_Kimetsu_no_Yaiba',
        tags: ['Manga', 'Shounen', '★']
    },
    {
        image: helltaker,
        title: 'Helltaker',
        color: '#000000',
        date: '05/27/20',
        url:'https://en.wikipedia.org/wiki/Helltaker',
        text: "Horrible story about horrible people.",
        tags: ['Game', 'PC']
    },
    {
        image: joshiraku,
        title: 'Joshiraku',
        color: '#A0522D',
        date: '05/20',
        url:'https://en.wikipedia.org/wiki/Joshiraku',
        text: "Stop that! They're working so hard to animate us even though there's so little to animate!",
        tags: ['Anime', 'Comedy']
    },
    {
        image: heartcatchprecure,
        title: 'HeartCatch PreCure!',
        color: '#7B68EE',
        date: '05/27/20',
        url:'https://en.wikipedia.org/wiki/HeartCatch_PreCure!',
        text: "Let's go save our planet.",
        tags: ['Anime', 'Mahou Shoujo', '★']
    },
    {
        image: saoaggo2,
        title: 'Sword Art Online Alternative Gun Gale Online Vol. 2',
        color: '#DDA0DD',
        date: '05/20',
        url:'https://en.wikipedia.org/wiki/Sword_Art_Online_Alternative_Gun_Gale_Online',
        tags: ['Light Novel']
    },
    {
        image: hollowknight,
        title: 'Hollow Knight',
        color: '#5F9EA0',
        date: '06/07/20',
        url:'https://en.wikipedia.org/wiki/Hollow_Knight',
        text: "In the Black Vault far above. Through its sacrifice Hallownest lasts eternal.",
        tags: ['Game', 'PC', '★']
    },
    {
        image: mobpsycho,
        title: 'Mob Psycho 100',
        color: '#D3D3D3',
        date: '06/22/20',
        url:'https://en.wikipedia.org/wiki/Mob_Psycho_100',
        text: "All that was left in his heart was gratitude towards his master.",
        tags: ['Anime', 'Shounen', '★']
    },
    {
        image: Futari_wa_Pretty_Cure,
        title: 'Futari Wa, PreCure!',
        color: '#B0E0E6',
        date: '06/25/20',
        url:'https://en.wikipedia.org/wiki/Futari_wa_Pretty_Cure',
        text: "Bring it on!",
        tags: ['Anime', 'Mahou Shoujo', '★']
    },
    {
        image: kaguya2,
        title: 'Kaguya-Sama: Love is War - Season 2',
        color: '#8B0000',
        date: '07/27/20',
        url:'https://en.wikipedia.org/wiki/Kaguya-sama:_Love_Is_War',
        text: "Urusei Baka!",
        tags: ['Anime', 'Comedy', '★']
    },
    {
        image: asg2,
        title: 'Azure Striker Gunvolt 2',
        color: '#4682B4',
        date: '06/28/20',
        url:'https://en.wikipedia.org/wiki/Azure_Striker_Gunvolt_2',
        text: "With my song I'll protect him.",
        tags: ['Game', 'Switch', 'Replay']
    },
    {
        image: priconne,
        title: 'Princess Connect Re-Dive',
        color: '#BDB76B',
        date: '06/29/20',
        url:'https://en.wikipedia.org/wiki/Princess_Connect!_Re:Dive',
        text: "How crazy is that?",
        tags: ['Anime', 'Isekai', '★']
    },
    {
        image: junitaisen,
        title: 'Juni Taisen: Zodiac War',
        color: '#708090',
        date: '06/20',
        url:'https://en.wikipedia.org/wiki/Juni_Taisen:_Zodiac_War',
        tags: ['Light Novel']
    },
    {
        image: sekiro,
        title: 'Sekiro: Shadows Die Twice',
        color: '#2F4F4F',
        date: '07/03/20',
        url:'https://en.wikipedia.org/wiki/Sekiro:_Shadows_Die_Twice',
        text: "I hereby condemn the last immortal.",
        tags: ['Game', 'PS4', '★']
    },
    {
        image: bloodstained2,
        title: 'BloodStained Curse of the Moon 2',
        color: '#7B68EE',
        date: '07/18/20',
        url:'https://en.wikipedia.org/wiki/Go!_Princess_PreCure',
        tags: ['Game', 'PC', '★']
    },
    {
        image: saoa1,
        title: 'Sword Art Online Alicization',
        color: '#8B4513',
        date: '07/20',
        url:'https://en.wikipedia.org/wiki/Sword_Art_Online:_Alicization',
        text: "",
        tags: ['Anime', 'Shounen']
    },
    {
        image: tsugumomo,
        title: 'Tsugumomo Season 1',
        color: '#B0E0E6',
        date: '07/11/20',
        url:'https://en.wikipedia.org/wiki/Tsugumomo',
        tags: ['Anime', 'Seinen', '★']
    },
    {
        image: tsugumomo2,
        title: 'Tsugumomo Season 2',
        color: '#696969',
        date: '07/14/20',
        url:'https://en.wikipedia.org/wiki/Tsugumomo',
        tags: ['Anime', 'Seinen', '★']
    },
    {
        image: re2,
        title: 'Resident Evil 2',
        color: '#2F4F4F',
        date: '08/22/20',
        url:'https://en.wikipedia.org/wiki/Resident_Evil_2_(2019_video_game)',
        tags: ['Game', 'PS4', '★']
    },
    {
        image: arr,
        title: 'Final Fantasy 14: A Realm Reborn',
        color: '#87CEEB',
        date: '09/24/20',
        url:'https://en.wikipedia.org/wiki/Final_Fantasy_XIV',
        tags: ['Game', 'PC']
    },
    {
        image: umayon,
        title: 'Umayon',
        color: '#6495ED',
        date: '09/29/20',
        url:'https://umamusume.fandom.com/wiki/UmaYon',
        tags: ['Anime', 'Comedy']
    },
    {
        image: undertaleneutral,
        title: 'Undertale - Neutral',
        color: '#000000',
        date: '09/30/20',
        url:'https://en.wikipedia.org/wiki/Undertalee',
        text: "You called for help...",
        tags: ['Game', 'PC', '★']
    },
    {
        image: re4,
        title: 'Resident Evil 4',
        color: '#696969',
        date: '10/02/20',
        url:'https://en.wikipedia.org/wiki/Resident_Evil_4',
        text: "Saddler, you're small-time",
        tags: ['Game', 'PS4', '★']
    },
    {
        image: bunnydream,
        title: 'Rascal Does Not Dream of Bunny Girl Senpai',
        color: '#191970',
        date: '10/03/20',
        url:'https://en.wikipedia.org/wiki/Rascal_Does_Not_Dream_of_a_Dreaming_Girl',
        tags: ['Anime', 'Movie', '★']
    },
    {
        image: catreturns,
        title: 'The Cat Returns',
        color: '#87CEEB',
        date: '10/03/20',
        url:'https://en.wikipedia.org/wiki/The_Cat_Returns',
        tags: ['Anime', 'Movie']
    },
    {
        image: saoa2,
        title: 'SAO -Alicization- War of Underworld',
        color: '#800000',
        date: '10/03/20',
        url: 'https://en.wikipedia.org/wiki/Sword_Art_Online:_Alicization',
        tags: ['Anime', 'Shonen']
    },
    {
        image: undertalepacifist,
        title: 'Undertale - Pacifist',
        color: '#000000',
        date: '10/08/20',
        url:'https://en.wikipedia.org/wiki/Undertale',
        text: "But, it refused",
        tags: ['Game', 'PC', '★']
    },
    {
        image: AC7,
        title: 'Ace Combat 7: Skies Unknown',
        color: '#708090',
        date: '10/13/20',
        url:'https://en.wikipedia.org/wiki/Ace_Combat_7:_Skies_Unknownre',
        text: "There are pilots like you in every generation. And I have felled every one of them.",
        tags: ['Game', 'PS4', '★']
    },
    {
        image: ikaruga,
        title: 'Ikaruga',
        color: '#DCDCDC',
        date: '10/17/20',
        url:'https://en.wikipedia.org/wiki/Ikaruga',
        text: "Releasing restraint device. Removal of the limiter will cause overheat and possible destruction of the ship. ...Was I helpful for you? ...I am deeply grateful to you",
        tags: ['Game', 'PC', 'Replay']
    },
    {
        image: goose,
        title: 'Untitled Goose Game',
        color: '#708090',
        date: '10/21/20',
        url:'https://en.wikipedia.org/wiki/Untitled_Goose_Game',
        text: "Honk",
        tags: ['Game', 'PS4', '★']
    },
    {
        image: sonicmania,
        title: 'Sonic Mania',
        color: '#191970',
        date: '10/24/20',
        url:'https://en.wikipedia.org/wiki/Sonic_Mania',
        tags: ['Game', 'PC']
    },
    {
        image: sonicgenerations,
        title: 'Sonic Generations',
        color: '#800000',
        date: '10/26/20',
        url:'https://en.wikipedia.org/wiki/Sonic_Generations',
        text: "I beat you all the time by myself, and now there's two of me!",
        tags: ['Game', 'PC']
    },
    {
        image: celeste,
        title: 'Celeste',
        color: '#DAA520',
        date: '10/28/20',
        url:'https://en.wikipedia.org/wiki/Celeste_(video_game)',
        text: "You can do this.",
        tags: ['Game', 'PC', '★']
    },
    {
        image: re5,
        title: 'Resident Evil 5',
        color: '#A0522D',
        date: '10/31/20',
        url:'https://en.wikipedia.org/wiki/Resident_Evil_5',
        text: "And you're going to judge us? Do you get all your ideas from comic book villains?",
        tags: ['Game', 'PS4']
    },
    {
        image: mmx,
        title: 'Megaman X',
        color: '#191970',
        date: '11/06/20',
        url: 'https://en.wikipedia.org/wiki/Mega_Man_X',
        tags: ['Game', 'PS4', 'Replay']
    },
    {
        image: elaina1,
        title: 'Wandering Witch: the Journey of Elaina vol 1',
        color: '#7B68EE',
        date: '11/23/20',
        url:'https://en.wikipedia.org/wiki/Wandering_Witch:_The_Journey_of_Elaina',
        text: "That's right. She's me.",
        tags: ['Light Novel']
    },
    {
        image: luminousavenger,
        title: 'Gunvolt Chronicles: Luminous Avenger IX',
        color: '#000000',
        date: '12/01/20',
        url: 'https://azurestrikergunvolt.fandom.com/wiki/Gunvolt_Chronicles:_Luminous_Avenger_iX',
        text: "Dual blades perform their fervorous dance, ready to strike with conviction.",
        tags: ['Game', 'PS4', 'Replay']
    },
    {
        image: elaina2,
        title: 'Wandering Witch: the Journey of Elaina vol 2',
        color: '#556B2F',
        date: '12/05/20',
        url:'https://en.wikipedia.org/wiki/Wandering_Witch:_The_Journey_of_Elaina',
        tags: ['Light Novel']
    },
    {
        image: celestefarewell,
        title: 'Celeste - Farewell',
        color: '#BA55D3',
        date: '12/14/20',
        url:'https://celestegame.fandom.com/wiki/Chapter_9:_Farewell',
        text: "Say goodbye to her for me.",
        tags: ['Game', 'PC', '★']
    },
    {
        image: Assassination_Classroom,
        title: 'Assassination Classroom',
        color: '#8B4513',
        date: '12/17/20',
        url:'https://en.wikipedia.org/wiki/Assassination_Classroom',
        text: "It was a really...really fun year.",
        tags: ['Anime']
    },
    {
        image: tonikawa,
        title: 'TONIKAWA: Over The Moon For You',
        color: '#00008B',
        date: '12/18/20',
        url:'https://en.wikipedia.org/wiki/Fly_Me_to_the_Moon_(manga)',
        text: "We can be together...if you'll marry me.",
        tags: ['Anime']
    },
    {
        image: elainaS1,
        title: 'Wandering Witch: The Journey of Elaina',
        color: '#8B0000',
        date: '12/18/20',
        url:'https://en.wikipedia.org/wiki/Wandering_Witch:_The_Journey_of_Elaina',
        text: "It's the person traveling and writing my--our--story, Wandering Witch. That's right. It's me!",
        tags: ['Anime', '★']
    },
    {
        image: haikyuuS4,
        title: 'Haikyuu!!: To the Top!',
        color: '#FFA500',
        date: '12/18/20',
        url:'https://haikyuu.fandom.com/wiki/Haiky%C5%AB!!_Season_4',
        text: "KAGEYAMAAAAA!",
        tags: ['Anime', '★']
    },
    {
        image: touhoulunanight,
        title: 'Touhou Luna Nights',
        color: '#808080',
        date: '12/30/20',
        url:'https://store.steampowered.com/app/851100/Touhou_Luna_Nights/',
        text: "Night of Nights",
        tags: ['Game', 'PC',  '★']
    },
]